import { useQuery } from '@tanstack/react-query';

import getV2StockMtOrderlistfilterById from '@services/api/stock/order/marginDetail';

/**
 * @param {string}  orderNo
 */
function useOrderMtDetail(orderNo) {
  const { cb, key } = getV2StockMtOrderlistfilterById(orderNo);

  const { data, isSuccess, isLoading } = useQuery(key, cb, {
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return { data, isSuccess, isLoading };
}

export default useOrderMtDetail;
